"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const query = (0, client_1.gql) `
  query webFlowSites {
    webFlowSites {
      name
      webFlowId
      enabled
      createdAt
      updatedAt
      previewUrl
      domains {
        lastPublishedAt
        name
      }
    }
  }
`;
exports.default = query;
//# sourceMappingURL=webFlowSites.query.js.map